var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "background-color": "white", padding: "24px" } },
    [
      _c(
        "a-form",
        { attrs: { rules: _vm.validatorRules } },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { md: 20, sm: 8 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["system.departSigne.form"]
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            allowClear: "",
                            "show-search": "",
                            "option-filter-prop": "children",
                            placeholder:
                              _vm.language["common.pleaseChoose"] +
                              _vm.language["system.departSigne.form"]
                          },
                          on: { change: _vm.formChange },
                          model: {
                            value: _vm.formCode,
                            callback: function($$v) {
                              _vm.formCode = $$v
                            },
                            expression: "formCode"
                          }
                        },
                        _vm._l(_vm.formList, function(item, index) {
                          return _c(
                            "a-select-option",
                            {
                              key: index.toString(),
                              attrs: { value: item.formCode }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.formName) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { md: 20, sm: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["system.departSigne.process"]
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            allowClear: "",
                            "show-search": "",
                            "option-filter-prop": "children",
                            placeholder:
                              _vm.language["common.pleaseChoose"] +
                              _vm.language["system.departSigne.process"]
                          },
                          on: { change: _vm.modelChange },
                          model: {
                            value: _vm.modelGuid,
                            callback: function($$v) {
                              _vm.modelGuid = $$v
                            },
                            expression: "modelGuid"
                          }
                        },
                        _vm._l(_vm.modelList, function(item, index) {
                          return _c(
                            "a-select-option",
                            {
                              key: index.toString(),
                              attrs: { value: item.modelGuid }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.pfBpmModel.modelNameLocalLang) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "search" },
                          on: { click: _vm.initTable }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.language["system.departSigne.load"])
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("a-table", {
        attrs: {
          pagination: false,
          bordered: "",
          size: "middle",
          rowKey: "id",
          columns: _vm.columns,
          dataSource: _vm.dataSource
        },
        scopedSlots: _vm._u([
          {
            key: "userNames",
            fn: function(text, record, index) {
              return [
                record.editable
                  ? _c(
                      "div",
                      [
                        _c("j-select-user", {
                          attrs: {
                            isSort: true,
                            multiple: true,
                            sortItem: record,
                            url: _vm.signedUserURL,
                            rowKey: "workNo"
                          },
                          on: { handleSortOk: _vm.handleSortOk },
                          model: {
                            value: record.userCodes,
                            callback: function($$v) {
                              _vm.$set(record, "userCodes", $$v)
                            },
                            expression: "record.userCodes"
                          }
                        })
                      ],
                      1
                    )
                  : _c("div", [_vm._v(_vm._s(text))])
              ]
            }
          },
          {
            key: "isOrder",
            fn: function(text, record, index) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      text == "1"
                        ? _vm.language["common.yes"]
                        : _vm.language["common.no"]
                    ) +
                    "\n      "
                )
              ]
            }
          },
          {
            key: "skipApproval",
            fn: function(text, record, index) {
              return [
                record.editable
                  ? _c(
                      "div",
                      [
                        _c(
                          "a-radio-group",
                          {
                            model: {
                              value: record.skipApproval,
                              callback: function($$v) {
                                _vm.$set(record, "skipApproval", $$v)
                              },
                              expression: "record.skipApproval"
                            }
                          },
                          [
                            _c("a-radio", { attrs: { value: "1" } }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.language["common.yes"]) +
                                  "\n            "
                              )
                            ]),
                            _c("a-radio", { attrs: { value: "0" } }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.language["common.no"]) +
                                  "\n            "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            text == "1"
                              ? _vm.language["common.yes"]
                              : _vm.language["common.no"]
                          ) +
                          "\n        "
                      )
                    ])
              ]
            }
          },
          {
            key: "action",
            fn: function(text, record, index) {
              return [
                _c("div", { staticClass: "editable-row-operations" }, [
                  record.editable
                    ? _c(
                        "span",
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function() {
                                  return _vm.save(record)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.save"]))]
                          ),
                          _c("a-divider", { attrs: { type: "vertical" } }),
                          _c(
                            "a-popconfirm",
                            {
                              attrs: {
                                title: _vm.language["message.giveUpEditing"]
                              },
                              on: {
                                confirm: function() {
                                  return _vm.cancel(record)
                                }
                              }
                            },
                            [
                              _c("a", [
                                _vm._v(_vm._s(_vm.language["common.cancel"]))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "edit",
                            on: {
                              click: function() {
                                return _vm.edit(record.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.language["common.edit"]))]
                        )
                      ])
                ])
              ]
            }
          },
          {
            key: "footer",
            fn: function() {
              return [
                _vm.noticeShow
                  ? _c(
                      "a-form",
                      { attrs: { rules: _vm.validatorRules } },
                      [
                        _c(
                          "a-row",
                          { attrs: { gutter: 24 } },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 16, sm: 16 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label:
                                        _vm.language[
                                          "system.departSigne.InformPersonnel"
                                        ]
                                    }
                                  },
                                  [
                                    _c("j-select-user", {
                                      attrs: {
                                        multiple: true,
                                        url: _vm.signedUserURL,
                                        rowKey: "workNo",
                                        disabled: !_vm.noticeShow
                                      },
                                      model: {
                                        value: _vm.noticeUsers,
                                        callback: function($$v) {
                                          _vm.noticeUsers = $$v
                                        },
                                        expression: "noticeUsers"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "div",
        { staticStyle: { "padding-top": "10px", "text-align": "end" } },
        [
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "signedModel:submit",
                  expression: "'signedModel:submit'"
                }
              ],
              staticStyle: { right: "1%" },
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitTable("0")
                }
              }
            },
            [_vm._v(_vm._s(_vm.language["common.submitButton"]))]
          ),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "signedModel:coerceSubmit",
                  expression: "'signedModel:coerceSubmit'"
                }
              ],
              attrs: { type: "primary" },
              on: { click: _vm.coerceSubmit }
            },
            [_vm._v(_vm._s(_vm.language["common.coerceSubmit"]))]
          )
        ],
        1
      ),
      _c("div", { staticStyle: { "padding-top": "20px" } }, [
        _c("span", { staticStyle: { "font-weight": "800" } }, [
          _vm._v(_vm._s(_vm.language["common.operatingInstructions"]) + "：")
        ]),
        _c("ul", [
          _c("li", [
            _vm._v(
              _vm._s(
                _vm.language["departSignedModel.operatingInstructions_one"]
              )
            )
          ]),
          _c("li", [
            _vm._v(
              _vm._s(
                _vm.language["departSignedModel.operatingInstructions_two"]
              )
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }